import type { DateTime } from "luxon";

/**
 * Given a date and a format, return the formatted date.
 */
export function formatDate(params: {
  date: DateTime;
  format: "Jan 1, 2025" | "Wed, Jan 1 at 3:30 pm" | "Wed, Jan 1" | "Wed, Jan 1, 2025";
}) {
  const { date, format } = params;

  switch (format) {
    case "Jan 1, 2025":
      return date.toFormat("MMM d, yyyy");
    case "Wed, Jan 1":
      return date.toFormat("ccc, MMM d");
    case "Wed, Jan 1, 2025":
      return date.toFormat("ccc, MMM, d, yyyy");
    case "Wed, Jan 1 at 3:30 pm":
      return `${date.toFormat("ccc, MMM d")} at ${date.toFormat("h:mm a").toLowerCase()}`;
    default:
      throw new Error(`Unsupported format: ${format}`);
  }
}
